export { Tabs } from './Tabs';
export * from './Tabs.types';
